import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import {
  GetPivotRowsBIZcoreTD
} from '../../../../../redux/actions/business/core/pivotRowsActions';

const PivotRowsPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.tradeDefence"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [rowsList, setRowsList] = useState([]);
  const [rowsTotal, setRowsTotal] = useState(0);

  const [
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    { label: "Id", sort: "id" },
    { label: "Pivot master id", sort: "ref_pivot_master_id" },
    { label: "DASI part number", sort: "dasi_part_number" },
    { label: "Raw instructed HTS", sort: "raw_instructed_hts" },
    { label: "USITC HTS id", sort: "ref_usitc_hts_id" },
    { label: "Instructed COO", sort: "instructed_coo" },
    { label: "Related party", sort: "is_related_party" },
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetRows();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      setRowsList(state.pivotRowsList.records || []);
      setRowsTotal(state.pivotRowsList.total || 0);
    } catch (err) {}
  }, [state]);

  async function handleGetRows(customLoading) {
    let query = "";
    if (search) query += `&search=${search}`;
    if (sort) query += `&ordering=${sortDirection === "asc" ? '' : '-'}${sort}`;
    dispatch(GetPivotRowsBIZcoreTD(page + 1, rowsPerPage, query, true, customLoading ? customLoading : setLoading));
  };

  return (
    <Box>

      <TopBar
        title={"Pivot rows"}
        search={search}
        onSearchChange={(e) => setSearch(e.target.value)}
      />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          rowsList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No pivot row found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    <TableCell key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort}
                        direction={sortDirection}
                        onClick={() => handleSort(heading.sort)}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rowsList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.ref_pivot_master_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>{row.dasi_part_number || <NA />}</TableCell>
                    <TableCell>{row.raw_instructed_hts || <NA />}</TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.ref_usitc_hts_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>{row.instructed_coo || <NA />}</TableCell>
                    <TableCell>
                      {row.is_related_party === true
                        ? <Chip size="small" color="warning" label="Yes" />
                        : <Chip size="small" color="default" label="No" />}
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  colSpan={7}
                  count={rowsTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
      }

    </Box>
  );
};

export default PivotRowsPage;
